<template>
    <div v-if="model.app.id && model.currentUser" class="notifications-container p-4">

<!--        <ul class="nav nav-tabs">-->
<!--            <li class="nav-item">-->
<!--                <a class="nav-link" :class="showNotifications ? 'active' : ''" href="javascript:void(0)" @click="showNotifications = true">Notifications</a>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--                <a class="nav-link" :class="!showNotifications ? 'active' : ''" href="javascript:void(0)" @click="showNotifications = false">Email Templates</a>-->
<!--            </li>-->
<!--        </ul>-->

        <notification-list></notification-list>

<!--        <email-templates v-else></email-templates>-->

    </div>
</template>

<script>
    import AppService from "../services/AppService";
    import EmailTemplateModal from "./EmailTemplateModal.vue";
    import EmailTemplates from "./EmailTemplates.vue";
    import NotificationList from "./NotificationList.vue";

    export default {
        name: 'Notifications',
        components: {NotificationList, EmailTemplates, EmailTemplateModal},
        props: ['prop1'],
        data() {
            return {
                model: webase.model,
                showNotifications: true
            }
        },
        mounted() {
            if (!this.model.app.id) {
                let appId = this.$route.params.id
                let appService = new AppService()

                appService.initApp(appId).then((response) => {
                    console.log('App initialized')
                }).catch((message) => {
                    console.log('error loading app')
                    console.log(message)
                })
            }
        }
    }
</script>

